import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { popSignUp, SignUpElement, SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import { useHistory } from "react-router-dom";
export var ForAnyRetailerBannerText = function() {
    var history = useHistory();
    return /*#__PURE__*/ _jsxs(Column, {
        align: {
            mobileAndAbove: "flex-start",
            tabletAndAbove: "center"
        },
        className: "w-full md:w-[240px] lg:w-[370px] 2xl:w-[500px]",
        gap: {
            mobileAndAbove: "2x",
            xLargeAndAbove: "3x",
            xxLargeDesktop: "4x"
        },
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "displaySSerifRegular",
                    tabletAndAbove: "pageHeaderSerifRegular",
                    desktopAndAbove: "displaySSerifRegular",
                    xLargeAndAbove: "displayMSerifRegular",
                    xxLargeDesktop: "displayLSerifRegular"
                },
                color: Core.text.inverse,
                align: {
                    mobileAndAbove: "start",
                    tabletAndAbove: "center"
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "T2GMlY",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "For any retailer, no matter what you sell."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "paragraphSansRegular",
                    xxLargeDesktop: "subheadingSansRegular"
                },
                color: Core.text.inverse,
                align: {
                    mobileAndAbove: "start",
                    tabletAndAbove: "center"
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "FkwQ6N",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Whether you buy for a clothing boutique or a grocery store, find all the products you need on Faire."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                onClick: function() {
                    return popSignUp(history, SignUpType.GENERIC, function() {
                        return null;
                    }, {
                        element: SignUpElement.BELOW_FOLD,
                        sourceId: "logged_out_homepage_for_any_retailer_banner"
                    });
                },
                className: "w-fit",
                "data-test-id": "for-any-retailer-banner-sign-up-button",
                variant: "secondary",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "IzbE3w",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Sign up to buy"
                        }
                    ]
                })
            })
        ]
    });
};
